<homey-lotteries-dialog-content
  singleTitle="Lottery closed!"
  multipleTitle="Lotteries closed!"
  singleDescription="This lottery you applied to has now closed. In the coming weeks, the drawing will take place and a lottery number will be assigned to your application. We’ll keep you updated."
  multipleDescription="These lotteries you applied to have now closed. In the coming weeks, the drawing will take place and lottery numbers will be assigned to your applications. We’ll keep you updated."
  [closeButton]="closeButton()"
  [notification]="data()"
>
  <ng-template lotteryDialogListItem let-lottery>
    <homey-lottery-list-item [apartment]="lottery" [openInPopup]="true">
      <p>Waiting for lottery number</p>
    </homey-lottery-list-item>
  </ng-template>
</homey-lotteries-dialog-content>
